//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wikiSelect from '~/components/common/wikiSelect.vue'
import mobileTab from '~/components/common/mobileTab.vue'
import { getAppointNDay, getSeconds, getMonthDayMinute, getAppointNMonthHour } from '~/assets/js/utils.js'
export default {
  components: {
    wikiSelect, mobileTab
  },
  props: {
    explain: { // 折线图tips
      type: String,
      default: ''
    },
    lineList: { // 折线图数据
      type: Array,
      default: () => []
    },
    explainScatter: { // 散点图tips
      type: String,
      default: ''
    },
    scatterList: { // 散点图数据
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selectIndex: 1,
      updatetime: '', // 更新时间
      startTime: '2023-03-20 11:35:56',
      endTime: '2023-03-23 11:35:56',
      lineSymbol: 'EURUSD', // 折线图当前品种
      scatterSymbol: 'EURUSD', // 散点图当前品种
      costText: '',
      bigText: '',
      myChartLine: null, // 折线图实例
      myChartScatter: null, // 散点图实例
      tabName: [ // tab数据
        { name: 'EURUSD', code: 0 },
        { name: 'GBPUSD', code: 1 },
        { name: 'AUDUSD', code: 2 },
        { name: 'USDJPY', code: 3 },
        { name: 'USDCAD', code: 4 },
        { name: 'NZDUSD', code: 5 },
        { name: 'USDCHF', code: 6 },
        { name: 'XAUUSD', code: 7 },
        { name: 'EURAUD', code: 8 },
        { name: 'GBPJPY', code: 9 }
      ],
      optionList: [
        { value: 1, label: '28668' },
        { value: 2, label: '15544' },
        { value: 3, label: '12764' }
      ]
    }
  },
  watch: {
    // 监听屏幕宽度的变化
    '$store.state.screenWidth' (newV) {
      this.myChartLine?.resize()
      this.myChartScatter?.resize()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.handleLineData(this.explain, this.lineList)
      this.handleScatterData(this.explainScatter, this.scatterList)
    })
  },
  methods: {
    // 切换年限
    changeOption ({ value }) {
      this.getStartTime(value)
      this.selectIndex = value
      this.endTime = getSeconds()
      this.getLineData(this.lineSymbol, 3, this.startTime, this.endTime)
      this.getScatterData(this.scatterSymbol, 3, this.startTime, this.endTime)
    },
    // 存储开始时间
    getStartTime (value) {
      if (value == 1) {
        this.startTime = getAppointNDay('', 3)
      } else if (value == 2) {
        this.startTime = getAppointNDay('', 7)
      } else {
        this.startTime = getAppointNMonthHour('', 1)
      }
    },
    // 价值线select切换
    mobileTab ({ index }) {
      this.getStartTime(this.selectIndex)
      this.lineSymbol = this.tabName[index].name
      this.getLineData(this.lineSymbol, 3, this.startTime, getSeconds())
    },
    // 大单异动select切换
    bigMobileTab ({ index }) {
      this.getStartTime(this.selectIndex)
      this.scatterSymbol = this.tabName[index].name
      this.getScatterData(this.scatterSymbol, 3, this.startTime, getSeconds())
    },
    // 处理折线图数据
    handleLineData (explain, list) {
      const [data1, data2, data3, xData] = [[], [], [], []]
      const newList = list.reverse()
      newList.forEach((item, index) => {
        if (index == newList?.length - 1) this.updatetime = item?.create_at
        xData.push(item.create_at) // x轴数据
        data1.push({ name: item.create_at, value: item.price })
        data2.push({ name: item.create_at, value: item.price_long })
        data3.push({ name: item.create_at, value: item.price_short })
      })
      this.costText = explain
      this.lineCharts(xData, data1, data2, data3)
    },
    // 处理散点图数据
    handleScatterData (explain, list) {
      const [data1, data2, xData] = [[], [], []]
      const newList = list.reverse()
      // console.log(newList)
      newList.forEach((item) => {
        if (item.ordertype != 1) {
          data1.push([
            item.opentime,
            item.lots
          ])
        } else {
          data2.push([
            item.opentime,
            item.lots
          ])
        }
        xData.push(item.opentime)
      })
      this.bigText = explain
      this.scatterCharts(xData, data1, data2)
    },
    // 获取折线图数据
    async getLineData (symbol = 'eurusd', num = 3, startTime = '2023-01-29 00:00:12', endTime = '2023-02-01 10:12:34', apiLanguage = this.currLangCode()) {
      try {
        const { explain = '', trendForPrice: list = [] } = await this.$api.common.invokeClient({ HttpMethod: 'post', Route: '/mt4Extend/trendForPrice' }, { symbol, num, startTime, endTime, apiLanguage })
        this.handleLineData(explain, list)
      } catch {}
    },
    // 折线图
    lineCharts (xData, data1, data2, data3) {
      this.myChartLine?.clear()
      if (!this.myChartLine) this.myChartLine = this.$echarts.init(document.getElementsByClassName('tracking-line-charts')[0])
      const option = {
        color: ['#3B76F6', '#E2A653', '#E9834C'],
        grid: {
          top: '10%',
          bottom: '15%',
          right: '6%',
          left: '5%',
          containLabel: true
        },
        legend: {
          type: 'scroll',
          data: [this.$t('TYY_000321'), this.$t('28985'), this.$t('28986')],
          bottom: '0',
          icon: 'rect',
          itemWidth: 10,
          itemHeight: 2,
          itemGap: 20,
          selectedMode: false,
          textStyle: {
            color: '#3D3D3D',
            fontSize: 12,
            align: 'middle'
          }
        },
        xAxis: [
          {
            type: 'category',
            data: xData,
            boundaryGap: true,
            axisTick: {
              show: false
            },
            axisLine: {
              show: true
            },
            axisLabel: {
              color: '#7A7A7A',
              margin: 10,
              fontSize: 12,
              formatter: value => getMonthDayMinute(value)
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: ['rgba(0, 0, 0, 0.05)']
              }
            }
          }
        ],
        yAxis: [
          {
            min: 'dataMin',
            nameTextStyle: {
              color: '#A3A3A3',
              fontSize: 12
            },
            type: 'value',
            axisLabel: {
              color: '#A3A3A3',
              formatter: value => (value - 0).toFixed(2)
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: ['rgba(0, 0, 0, 0.05)']
              }
            }
          }
        ],
        tooltip: {
          confine: true,
          trigger: 'axis',
          backgroundColor: 'rgba(0,0,0,0.8)',
          formatter: (params) => {
            let dom = ''
            params.forEach((item, i) => {
              dom += `<div class="item"><span class="dot${i}"></span>${item.value}</div>`
            })
            return `<div class="trading-tooltip-box">
                      <div class="time">${params[0].data.name}</div>
                      ${dom}
                    </div>`
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              type: 'dashed',
              color: 'rgba(0,0,0,0)'
            }
          }
        },
        series: [
          {
            type: 'line',
            name: this.$t('TYY_000321'),
            data: data1,
            smooth: true, // 平滑曲线
            showSymbol: false,
            symbol: 'circle',
            symbolSize: 8
          },
          {
            type: 'line',
            name: this.$t('28985'),
            data: data2,
            smooth: true, // 平滑曲线
            showSymbol: false,
            symbol: 'circle',
            symbolSize: 8
          },
          {
            type: 'line',
            name: this.$t('28986'),
            data: data3,
            smooth: true, // 平滑曲线
            showSymbol: false,
            symbol: 'circle',
            symbolSize: 8
          }
        ]
      }
      this.myChartLine?.setOption(option, true)
    },
    // 获取散点图数据
    async getScatterData (symbol = 'eurusd', num = 3, startTime = '2023-01-27 00:00:12', endTime = '2023-02-01 10:12:34', apiLanguage = this.currLangCode()) {
      try {
        const { explain = '', bigTradeList: list = [] } = await this.$api.common.invokeClient({ HttpMethod: 'post', Route: '/mt4Extend/bigTrade' }, { symbol, num, startTime, endTime, apiLanguage })
        this.handleScatterData(explain, list)
      } catch {}
    },
    scatterCharts (xData, data1, data2) {
      if (!this.myChartScatter) this.myChartScatter = this.$echarts.init(document.getElementsByClassName('scatter-charts')[0])
      const that = this
      const option = {
        color: ['#2E9987', '#C7344C'],
        grid: {
          left: '10%',
          right: '10%',
          top: '13%',
          bottom: '24%'
        },
        legend: {
          data: [this.$t('28987'), this.$t('28988')],
          bottom: '0',
          icon: 'circle',
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 20,
          // selectedMode: false,
          textStyle: {
            color: '#3D3D3D',
            fontSize: 12,
            align: 'middle'
          }
        },
        tooltip: {
          borderColor: 'rgba(0,0,0,0.8)',
          backgroundColor: 'rgba(0,0,0,0.8)',
          trigger: 'item',
          confine: true,
          axisPointer: {
            type: 'none'
          },
          formatter (params) {
            return `
            <div class="scatter-tooltip">
              <div>${that.scatterSymbol}  ${params.seriesName == '买单' ? that.$t('TYY_000421') : that.$t('TYY_000422')}</div>
              <div>${that.$t('19426')}：${params.name}</div>
              <div>${that.$t('TYY_000325')}：${params.data[1]}</div>
            </div>`
          }
        },
        xAxis: {
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#292929',
              width: 1
            }
          },
          axisLabel: {
            formatter: value => getMonthDayMinute(value),
            fontSize: 12,
            color: '#7A7A7A'
          },
          data: xData
        },
        yAxis: {
          position: 'right',
          offset: 5,
          splitLine: {
            lineStyle: {
              color: '#F7F7F7'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#D6D6D6',
              width: 1
            }
          },
          axisLabel: {
            show: true,
            fontSize: 12,
            color: '#7A7A7A'
          }
        },
        series: [
          {
            name: this.$t('28987'),
            data: data1,
            type: 'scatter',
            symbolSize: 12
          },
          {
            name: this.$t('28988'),
            data: data2,
            type: 'scatter',
            symbolSize: 12
          }
        ]
      }
      this.myChartScatter?.setOption(option, true)
    }
  }
}
